import { getExpiryDate } from './utils'

export const productsInitialState = {
  products: [],
  productsExp: null,
  billingCycleTypes: [],
  billingCycleTypesExp: null,
}

export const PRODUCTS_ACTIONS = {
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_BILLING_CYCLE_TYPES: 'SET_BILLING_CYCLE_TYPES',
}

export const productsActions = {
  [PRODUCTS_ACTIONS.SET_PRODUCTS]: (_, { products }) => {
    return { products, productsExp: getExpiryDate() }
  },
  [PRODUCTS_ACTIONS.SET_BILLING_CYCLE_TYPES]: (_, { billingCycleTypes }) => {
    return { billingCycleTypes, billingCycleTypesExp: getExpiryDate() }
  },
}
